"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reduce = void 0;
const walk_1 = require("../walk");
function reduce(source, initialValue, fn) {
    let val = initialValue;
    for (let node of walk_1.walkStep(source))
        val = fn(val, node);
    return val;
}
exports.reduce = reduce;
